import Bold from './caret-down.bold.svg?react'
import Duotone from './caret-down.duotone.svg?react'
import Fill from './caret-down.fill.svg?react'
import Regular from './caret-down.regular.svg?react'
import { createIcon } from './factory'

export const CaretDown = createIcon({ regular: Regular, bold: Bold, fill: Fill, duotone: Duotone })
